/** Sidebar / 로그인 후 홈과 동일한 경로 규칙 */

export const routeCanonicalMap = {
    '/findnaverranktracking': '/findNaverRankTracking',
    '/findnaverrank': '/findNaverRank',
    '/findmid': '/findMid',
    '/findproductbymid': '/findProductByMid',
    '/keywordver1': '/keywordVer1',
    '/keywordver2': '/keywordVer2',
    '/naverintegratedrank': '/NaverIntegratedRank',
    '/keywordrankvolumecheck': '/KeywordRankVolumeCheck',
    '/changeurl': '/changeUrl',
    '/counttext': '/countText',
    '/integratedsearch': '/integratedSearch',
    '/productanalysis': '/product-analysis',
    '/rankhistorywatch': '/rankHistoryWatch',
    '/autocomplete': '/autoComplete',
    '/productgenerate': '/productGenerate',
    '/slot-guide': '/slot-guide',
};

export function toCanonicalPath(path) {
    if (!path || typeof path !== 'string') return path;
    return routeCanonicalMap[path.toLowerCase()] ?? path;
}

function parseMenuJson(key) {
    try {
        const raw = localStorage.getItem(key);
        return raw ? JSON.parse(raw) : [];
    } catch {
        return [];
    }
}

function useYnFilter(m) {
    const v = (m?.use_yn ?? 'Y').toString().trim().toUpperCase();
    return v === 'Y' || v === '1' || v === 'TRUE';
}

function sortBySortOrder(a, b) {
    return (a?.sort_order ?? 0) - (b?.sort_order ?? 0);
}

/**
 * 로그인 시 서버가 내려준 naverMenu + toolMenu 기준,
 * 사이드바에 보이는 순서의 첫 메뉴 경로 (MainLayout과 동일 규칙).
 * 없으면 null.
 */
function getOrderedMenusFromStorage() {
    const naverMenu = parseMenuJson('tsad_ranking_naverMenu').filter(useYnFilter);
    const toolMenu = parseMenuJson('tsad_ranking_toolMenu').filter(useYnFilter);
    const guideMenu = parseMenuJson('tsad_ranking_guideMenu').filter(useYnFilter);

    return [
        ...[...naverMenu].sort(sortBySortOrder),
        ...[...toolMenu].sort(sortBySortOrder),
        ...[...guideMenu].sort(sortBySortOrder),
    ];
}

/** 사이드바 순서의 메뉴 경로 배열 (정규화됨) */
export function getOrderedMenuPathsFromStorage() {
    return getOrderedMenusFromStorage()
        .filter(m => m?.path && typeof m.path === 'string')
        .map(m => toCanonicalPath(m.path));
}

/**
 * 현재 페이지에 권한이 없을 때 시도할 다음 메뉴 경로.
 * (같은 순서에서 뒤쪽 → 없으면 앞쪽 다른 항목)
 */
export function getNextFallbackMenuPath(currentCanonicalPath) {
    const paths = getOrderedMenuPathsFromStorage();
    if (!paths.length) return null;
    const cur = currentCanonicalPath;
    const i = paths.indexOf(cur);
    if (i >= 0 && paths[i + 1]) return paths[i + 1];
    const other = paths.find(p => p !== cur);
    return other ?? null;
}

export function getFirstAllowedMenuPathFromStorage() {
    const ordered = getOrderedMenusFromStorage();
    const first = ordered.find(m => m?.path && typeof m.path === 'string');
    return first ? toCanonicalPath(first.path) : null;
}
